






































































import { FormBlock } from '@/app/components';
import { offlineRetentionOptions } from '@/modules/asset/config/asset';
import { ContractStatus, ExpectedUsage, ExpectedUsageText } from '@/modules/sharing/constants';
import { PropType, computed, defineComponent } from '@vue/composition-api';
import HtmlDiff from 'htmldiff-js';
import { useContractMetadata } from '../../composable';
import { Contract, ContractTransaction, DerivationContract } from '../../types';
// import LicenseDetail from './LicenseDetail.vue';
import { AssetTypeId } from '@/modules/asset/constants';

export default defineComponent({
    name: 'LicenseDetails',
    components: {
        FormBlock,
        // LicenseDetail,
    },
    props: {
        contract: {
            type: Object as PropType<Contract | DerivationContract>,
            required: true,
        },
        onEditMode: {
            type: Boolean,
            default: false,
        },
        previousNegotiation: {
            type: Object as PropType<ContractTransaction>,
            default: () => ({}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const { getLicensingSchema, getExpectedUpdatesSchema } = useContractMetadata(props.contract, props.disabled);
        const isDerivationContract = computed(() => 'sellerOrgId' in props.contract);
        const isModelAsset = computed(() =>
            isDerivationContract.value
                ? (props.contract as DerivationContract)?.sellingAsset?.assetTypeId === AssetTypeId.Model
                : props.contract?.asset?.assetTypeId === AssetTypeId.Model,
        );

        const getHtmlList = (texts: string[]) => {
            if (texts) {
                const result = ['<ul>'];
                texts.forEach((text: string) => {
                    result.push(`<li>${text}</li>`);
                });
                result.push('</ul>');
                return result.join('');
            }
            return null;
        };

        const expectedUsage = computed(() => {
            if (!props.contract.metadata.license.expectedUsage) return null;
            const options = Object.values(ExpectedUsageText);
            const newValues = props.contract.metadata.license.expectedUsage.map(
                (value: ExpectedUsage) => ExpectedUsageText[value],
            );
            if (
                props.contract.status === ContractStatus.Negotiate &&
                props.previousNegotiation?.changes.metadata?.license?.expectedUsage
            ) {
                const oldValues = props.previousNegotiation.changes.metadata.license.expectedUsage.map(
                    (value: ExpectedUsage) => ExpectedUsageText[value],
                );
                return { oldValues, newValues, options };
            }
            return { oldValues: undefined, newValues, options };
        });

        const offlineRetention = computed(() => {
            if (!props.contract.metadata.license.offlineRetention) return null;
            const options = offlineRetentionOptions;
            const newValues = props.contract.metadata.license.offlineRetention;
            if (
                props.contract.status === ContractStatus.Negotiate &&
                props.previousNegotiation?.changes.metadata?.license?.offlineRetention
            ) {
                const oldValues = props.previousNegotiation.changes.metadata.license.offlineRetention;
                return { oldValues, newValues, options };
            }
            return { oldValues: undefined, newValues, options };
        });

        const expectedUpdates = computed(() => {
            if (!props.contract.metadata.license.expectedUpdates?.unit) return null;
            const currentExpectedUpdatesHtml = getHtmlList([
                `${props.contract.metadata.license.expectedUpdates?.value ?? ''} ${
                    props.contract.metadata.license.expectedUpdates?.unit
                }`,
            ]);
            if (
                props.contract.status === ContractStatus.Negotiate &&
                props.previousNegotiation?.changes.metadata?.license?.expectedUpdates
            ) {
                const previousExpectedUpdatesHtml = getHtmlList([
                    `${props.previousNegotiation.changes.metadata.license.expectedUpdates.value ?? ''} ${
                        props.previousNegotiation.changes.metadata.license.expectedUpdates.unit
                    }`,
                ]);
                return HtmlDiff.execute(previousExpectedUpdatesHtml, currentExpectedUpdatesHtml);
            }
            return currentExpectedUpdatesHtml;
        });

        return {
            isDerivationContract,
            isModelAsset,
            getLicensingSchema,
            getExpectedUpdatesSchema,
            ContractStatus,
            expectedUsage,
            offlineRetention,
            expectedUpdates,
        };
    },
});
